import React from 'react'
import MixedContent from '../mixed-content'

export default function MixedContentDisplay(props) {
  const page = props?.node

  return <MixedContent page={page} />
}
